import {
  COMPONENT_VALUE_TYPES as types,
  SECTION_INTRO_LAYOUT as layouts,
  PERCENTAGES,
  BACKGROUND_IMAGE_POSITION,
  COMPONENT_COLOR_THEMES,
  COMPONENT_PARALLAX_SPEED,
} from 'shared/constants';

const propsSchema = [
  {
    key: 'section_tag',
    label: 'Section Tag',
    type: types.TEXT
  },
  {
    key: 'text_block',
    label: 'Text Block',
    type: types.OBJECT,
    children: [
      {
        key: 'text_animation',
        label: 'Text Animation',
        type: types.BOOLEAN
      },
      {
        key: 'divider_theme',
        label: 'Divider Theme',
        type: types.ENUM,
        options: COMPONENT_COLOR_THEMES
      },
      {
        key: 'section_header',
        label: 'Section Header',
        type: types.TEXT
      },
      {
        key: 'title',
        label: 'Title',
        type: types.TEXT
      },
      {
        key: 'description',
        label: 'Description',
        type: types.TEXTAREA
      },
    ]
  },
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES
      },
      {
        key: 'position',
        label: 'Background Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      },
      {
        key: 'disable_img',
        label: 'Solid Background Color',
        type: types.BOOLEAN
      },
      {
        key: 'background_color',
        label: 'Background Color',
        type: types.COLOR_PICKER
      }
    ]
  },
  {
    key: 'fixed_bg',
    label: 'Fixed Background',
    type: types.OBJECT,
    children: [
      {
        key: 'enable',
        label: 'Enable',
        type: types.BOOLEAN
      },
      {
        key: 'speed',
        label: 'Speed',
        type: types.ENUM,
        options: COMPONENT_PARALLAX_SPEED,
      },
    ]
  },
  {
    key: 'additional_overlay_img',
    label: 'Overlay Image',
    type: types.TEXT
  },
  {
    key: 'layout',
    label: 'Layout',
    type: types.ENUM,
    options: layouts
  },
  {
    key: 'height',
    label: 'Height',
    type: types.ENUM,
    options: PERCENTAGES
  }
];

const defaultProps = {
  section_tag: 'design',
  text_block: {
    text_animation: true,
    divider_theme: 'DARK',
    section_header: 'FF 91 DESIGN',
    title: 'A Beautiful Future',
    description: 'FF 91 is our first production vehicle and flagship model. All-electric, autonomous-ready and seamlessly connected, it embodies our latest mobility advancements in performance, intelligence, and user experience. Which is why we gave FF91 a future-forward design that visually sets it apart from anything else on the road.',
  },
  bg_img: {
    url: 'https://genesis-cdn.ff.com/product/07_design/ff-91-seating-design.jpg',
    dark_overlay: 0,
    position: 'CENTER CENTER',
    disable_img: false,
    background_color: '#FFFFFF'
  },
  fixed_bg: {
    enable: true,
    speed: 300,
  },
  additional_overlay_img: '',
  layout: 'LEFT 0',
  height: 100
};

export default {
  title: 'Section Intro',
  id: 'SectionIntro',
  propsSchema,
  defaultProps
};
